export default __webpack_public_path__ + "media/images/document-dossier-g384-vert-papier-icone-5474-96-63c7a454dbbe0d2a4d07f8c2340727e3.png";